"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M9 1a1 1 0 011-1h5a1 1 0 011 1v14a1 1 0 01-1 1h-5a1 1 0 01-1-1V1zM0 1a1 1 0 011-1h5a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1z"];
//# sourceMappingURL=layout-two-columns.js.map